import React from 'react';
import { ShieldX, LogOut, UserX } from 'lucide-react';
import { isEntraAuth, msalInstance } from '../auth/authConfig';
import { useAuth, writeImpersonation } from '../context/AuthContext';
import wmLogo from '../assets/logos/WM-Logo-CB-White-Header.png';

const AccessDeniedPage = () => {
  const { isImpersonating, realUser, stopImpersonating } = useAuth();
  const canStopImpersonating = isImpersonating && realUser?.isSysAdmin;

  const handleSignOut = () => {
    if (isEntraAuth() && msalInstance) {
      msalInstance.logoutRedirect();
      return;
    }
    localStorage.removeItem('pmd-identity');
    writeImpersonation(null);
    window.location.href = '/';
  };

  const handleStopImpersonating = () => {
    stopImpersonating();
    window.location.href = '/';
  };

  return (
    <div className="stui-auth-gate-backdrop">
      <div className="stui-auth-gate-card">

        {/* Branded header — matches auth gate */}
        <div className="stui-auth-gate-header">
          <img src={wmLogo} alt="Wunderlich-Malec" className="stui-auth-gate-logo" />
          <div className="stui-auth-gate-header-divider" />
          <div>
            <div className="stui-auth-gate-title">DAWN</div>
            <div className="stui-auth-gate-subtitle">DOCUMENTATION · ASSETS · WIRING · NETWORKING</div>
          </div>
        </div>

        {/* Content */}
        <div className="stui-auth-gate-body">
          <div className="stui-auth-gate-deadend">
            <ShieldX size={52} className="stui-text-error" />
            <div className="stui-auth-gate-deadend-title">Access Denied</div>
            <div className="stui-auth-gate-deadend-text">
              {canStopImpersonating
                ? 'The user you are impersonating does not have access to any databases. Stop impersonating to return to your SysAdmin view, or sign out.'
                : "You've authenticated successfully, but you don't have an account in DAWN. Contact an administrator to request access."}
            </div>
            <div className="stui-btn-row">
              {canStopImpersonating && (
                <button
                  onClick={handleStopImpersonating}
                  className="stui-btn stui-btn-primary"
                >
                  <UserX size={16} />
                  Stop Impersonating
                </button>
              )}
              <button
                onClick={handleSignOut}
                className="stui-btn stui-btn-secondary"
              >
                <LogOut size={16} />
                Sign Out
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AccessDeniedPage;
